"use client";

// React Imports
import { useRef, useState } from "react";

// MUI Imports
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import MoreVertIcon from "@mui/icons-material/MoreVert";
// Third-party Imports
import classnames from "classnames";
import { Link } from "react-router-dom";

// Type Imports

// Hook Imports

const IconButtonWrapper = (props) => {
  // Props
  const { tooltipProps, children } = props;

  return tooltipProps?.title ? (
    <Tooltip {...tooltipProps}>{children}</Tooltip>
  ) : (
    children
  );
};

const MenuItemWrapper = ({ children, option }) => {
  if (option.href) {
    return (
      <Box component={Link} href={option.href} {...option.linkProps}>
        {children}
      </Box>
    );
  } else {
    return <>{children}</>;
  }
};

const OptionMenu = (props) => {
  // Props
  const {
    tooltipProps,
    icon,
    iconClassName,
    options,
    leftAlignMenu,
    iconButtonProps,
  } = props;

  // States
  const [open, setOpen] = useState(false);

  // Refs
  const anchorRef = useRef(null);

  // Hooks

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <IconButtonWrapper tooltipProps={tooltipProps}>
        <IconButton
          ref={anchorRef}
          size="small"
          onClick={handleToggle}
          {...iconButtonProps}
        >
          {typeof icon === "string" ? (
            <i className={classnames(icon, iconClassName)} />
          ) : icon ? (
            icon
          ) : (
            <MoreVertIcon />
          )}
        </IconButton>
      </IconButtonWrapper>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement={leftAlignMenu ? "bottom-start" : "bottom-end"}
        transition
        disablePortal
        sx={{ zIndex: 1 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps}>
            <Paper className="shadow-lg">
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open}>
                  {options.map((option, index) => {
                    if (typeof option === "string") {
                      return (
                        <MenuItem key={index} onClick={handleClose}>
                          {option}
                        </MenuItem>
                      );
                    } else if ("divider" in option) {
                      return option.divider ? (
                        <Divider key={index} {...option.dividerProps} />
                      ) : null;
                    } else {
                      return (
                        <MenuItem
                          key={index}
                          {...option.menuItemProps}
                          {...(option.href && { className: "p-0" })}
                          onClick={(e) => {
                            handleClose(e);
                            option.menuItemProps?.onClick?.(e);
                          }}
                        >
                          <MenuItemWrapper option={option}>
                            {(typeof option.icon === "string" ? (
                              <i className={option.icon} />
                            ) : (
                              option.icon
                            )) || null}
                            {option.text}
                          </MenuItemWrapper>
                        </MenuItem>
                      );
                    }
                  })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default OptionMenu;
